module.exports = __webpack_public_path__ + "img/11.6cb48706.png";